import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';
import {
    FeatureFlag,
    IndividuallyLicensedFeature,
} from '@models';

@NgModule()
export class AnalyticsMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AnalyticsMetaModule,
            providers: [
                providePageMeta({
                    title: 'Insights',
                    translationKey: 'page_analytics',
                    permission: 'Analytics.View',
                    routerLink: '/insights',
                    svgIcon: 'uipath:analyticsSideNavIcon',
                    type: 'Sidebar',
                    sidebarSection: 'Monitoring',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Analytics,
                    licenseFlag: IndividuallyLicensedFeature.Analytics,
                    scope: PageScope.Global,
                    priority: 4,
                }),
                providePageMeta({
                    title: 'Insights',
                    translationKey: 'page_analytics',
                    permission: 'Analytics.View',
                    routerLink: '/insights/dashboards/:entityId',
                    parentRoute: '/insights',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Analytics,
                    licenseFlag: IndividuallyLicensedFeature.Analytics,
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
